module.exports = __webpack_public_path__ + "static/the-way-to-love-17c8b409c562c841e9eb1b461c7f49a6.jpg";